/*
  Sabre: scent note pop-up on product pages. Tap a "smells of" chip (snippets/bb-pdp-parts.liquid)
  and a sheet explains the note in the Bear Burners voice, with a link to shop other scents that share it.
  Copy lives in NOTES below (keys are lower case). Anything not listed falls back to its scent family
  in FAMILIES, keyed by the icon name from snippets/bb-note-icon.liquid.
*/
(function () {
  if (window.bbNotes) return;

  var NOTES = {
    'vanilla': 'Soft, creamy and endlessly comforting. Our vanilla is the warm hug at the heart of the scent, the bit that makes a room feel lived in.',
    'simply vanilla': 'Vanilla, nothing fancy. Smooth, creamy and sweet, like the inside of a freshly baked custard slice.',
    'vanilla musk': 'Creamy vanilla wrapped in clean, skin-soft musk. Cosy and grown up at the same time.',
    'vanilla frosting': 'Thick, buttery vanilla icing straight off the spoon. Sweet, soft and very hard to resist.',
    'amber vanilla': 'Golden amber melted into creamy vanilla. Warm, rich and glowing, like the last hour of a winter afternoon.',
    'tonka': 'A warm, almondy sweetness with a hint of hay and spice. Tonka gives a scent its cosy, lingering finish.',
    'cream': 'Rich and velvety, softening everything around it. A dollop of cream makes the whole scent feel indulgent.',
    'eggnog': 'Creamy, nutmeg-dusted and festive. Christmas in a glass, without the hangover.',
    'citrus': 'Bright, zesty and full of life. Citrus lifts a room in seconds, like opening the windows on a sunny morning.',
    'lemon': 'Sharp, sunny and squeaky clean. Freshly zested lemon that makes everything feel brighter.',
    'orange': 'Sweet, juicy orange peel. Cheerful and warm, with a little sparkle.',
    'blood orange': 'Deeper and juicier than your usual orange, with a ruby-red tang that wakes up the whole scent.',
    'orange blossom': 'Delicate white petals with a honeyed, sunny edge. Pretty, fresh and quietly romantic.',
    'bergamot': 'The fragrant citrus behind Earl Grey. Zesty, a little floral and wonderfully elegant.',
    'grapefruit': 'Tangy, juicy and bright pink. A burst of zing that keeps a scent feeling fresh.',
    'mandarin': 'Sweet, sunny and easy-going. Mandarin adds a soft, juicy brightness.',
    'musk': 'Clean, soft and warm, like freshly washed skin. Musk is the quiet note that makes a scent last and linger.',
    'cashmere': 'Soft, warm and a little powdery. It smells like your favourite jumper feels.',
    'linen': 'Crisp, line-dried sheets on a breezy day. Clean, calm and fresh.',
    'aldehydes': 'That sparkling, just-showered freshness. Aldehydes make a scent feel bright and airy.',
    'sugar': 'A sprinkle of pure sweetness. Sugar rounds off the sharper notes and makes the whole scent feel like a treat.',
    'pink sugar': 'Fluffy, candy-floss sweetness with a playful pink edge. Pure fairground nostalgia.',
    'almond': 'Toasty, nutty and softly sweet, like the top of a frangipane tart fresh from the oven.',
    'biscuit': 'Golden, buttery and freshly baked. A cup of tea is optional but encouraged.',
    'cookies': 'Warm cookies cooling on the tray. Buttery, sweet and gone far too quickly.',
    'sweet gingerbread cookies': 'Warm, spiced gingerbread fresh from the oven. Sticky, sweet and very Christmassy.',
    'bubblegum': 'Pink, playful and a bit cheeky. A big sweet bubble of a scent.',
    'candy cane': 'Sweet peppermint swirled with sugar. Crisp, cool and full of festive cheer.',
    'cherry candy': 'Glossy red cherry sweets from the corner shop jar. Sweet, fruity and fun.',
    'sugared fruit': 'Juicy fruit pieces rolled in sugar. Bright, sweet and a little bit nostalgic.',
    'fruity sweetness': 'A juicy, sweet-shop blend of fruits. Happy, bright and easy to love.',
    'jelly tots': 'The sweets of every childhood. Soft, fruity and sugar-dusted.',
    'white chocolate': 'Creamy, melting and smooth as anything. Sweet comfort in every breath.',
    'cocoa': 'Rich, dark and velvety, like a proper hot chocolate on a cold night.',
    'custard': 'Thick, warm and vanilla-sweet. Pour it over everything.',
    'liqueur': 'A warming splash of something sweet and boozy. Rich, smooth and a little bit indulgent.',
    'sherbet': 'Fizzy, sweet and tongue-tingling. A sherbet dip in scent form.',
    'amber': 'Warm, golden and slightly resinous. Amber is the glow of a scent, rich and comforting like firelight.',
    'incense': 'Smoky, spiced and calming. A wisp of incense adds depth and a quiet, peaceful mood.',
    'cherry': 'Dark, juicy cherry with a sweet, almost jammy richness. Ripe, fruity and a total crowd-pleaser.',
    'sparkling cherry': 'Bright red cherries with a fizzy, juicy pop. Fruity, fun and full of energy.',
    'raspberry': 'Plump, sun-ripened raspberries. Sweet, slightly tart and bursting with juice.',
    'strawberry': 'Sweet summer strawberries, just picked. Juicy, ripe and instantly happy.',
    'blueberry': 'Soft, juicy blueberries with a gentle sweetness. Fruity without being too much.',
    'rhubarb': 'Tart, pink and tangy. Rhubarb brings a sharp, juicy twist to anything sweet.',
    'pear': 'Crisp, juicy pear with a soft, green freshness. Light, clean and lovely.',
    'cassis': 'Deep, dark blackcurrant. Rich, tart and wonderfully juicy.',
    'cranberry': 'Tart, ruby-red and very festive. Cranberry adds a sharp, jewelled sparkle.',
    'red fruits': 'A bowl of ripe red berries. Sweet, juicy and bright.',
    'red currant': 'Little jewels of tart, juicy fruit. Fresh, bright and a touch sharp.',
    'redcurrant': 'Little jewels of tart, juicy fruit. Fresh, bright and a touch sharp.',
    'dark berries': 'Blackberries and blackcurrants picked late in the summer. Deep, juicy and moody.',
    'berries': 'A handful of mixed berries. Sweet, tangy and bursting with colour.',
    'plum': 'Rich, velvety and ripe. Plum gives a scent a deep, jammy warmth.',
    'apple': 'Crisp, juicy apple straight from the tree. Fresh, clean and cheerful.',
    'coconut': 'Creamy, tropical coconut. Sun-warmed, smooth and holiday-ready.',
    'lavender': 'Calm, herby and soothing. Our lavender is made for slowing down and unwinding at the end of the day.',
    'eucalyptus': 'Cool, clear and refreshing. Eucalyptus opens everything up, like a deep breath of spa air.',
    'peppermint': 'Cool, crisp and invigorating. A fresh blast of mint that wakes the whole room up.',
    'sage': 'Earthy, herby and calming. Sage adds a grounded, clean freshness.',
    'green leaf': 'Freshly crushed leaves and garden greenery. Crisp, green and alive.',
    'camphor': 'Cool, sharp and clearing. A herbal freshness that clears the head.',
    'pine': 'Fresh forest pine. Crisp, green and instantly outdoorsy, like a walk through the woods.',
    'winter pine': 'Frosty pine needles on a cold morning. Fresh, green and full of winter magic.',
    'pinecones': 'Woody, resinous and festive. Pinecones bring the forest floor indoors.',
    'fir': 'The smell of a real Christmas tree. Fresh, green and full of festive cheer.',
    'juniper': 'Crisp, slightly peppery evergreen berries. Fresh, clean and a little gin-like.',
    'balsam': 'Sweet, resinous fir balsam. Warm, woody and very wintry.',
    'patchouli': 'Earthy, rich and a little mysterious. Patchouli gives a scent depth and staying power.',
    'sandalwood': 'Smooth, creamy and softly woody. Sandalwood is calm, warm and beautifully grounding.',
    'cedar': 'Dry, clean cedarwood. Warm and woody, like a cosy cabin.',
    'cedarwood': 'Dry, clean cedarwood. Warm and woody, like a cosy cabin.',
    'woods': 'A warm blend of woods. Grounding, comforting and quietly confident.',
    'precious woods': 'Rich, polished woods with a smooth, luxurious warmth.',
    'exotic woods': 'Deep, smoky woods from far-off places. Warm, rich and a little bit daring.',
    'vetiver': 'Earthy, smoky roots with a green, grassy edge. Grounding and sophisticated.',
    'cypress': 'Fresh, green and woody, like a Mediterranean hillside after the rain.',
    'driftwood': 'Sun-bleached wood washed up on the shore. Salty, dry and beautifully calm.',
    'oak': 'Sturdy, warm oak. Woody, smooth and comforting.',
    'cherry sweetness with hidden woodland depth': 'Juicy, sweet cherry on top with a quiet woody warmth underneath. Sweet first, then cosy.',
    'lily': 'Elegant, airy and softly sweet. Fresh-cut lilies in a jug on the kitchen table.',
    'muguet': 'Lily of the valley. Fresh, green and delicate, the smell of an English spring.',
    'desert bloom': 'Bright, sun-warmed petals in an unexpected place. Fresh, floral and hopeful.',
    'rose': 'Soft, romantic and timeless. A gentle garden rose, never fussy.',
    'white orchid': 'Creamy, exotic and quietly elegant. A soft floral with a velvety touch.',
    'geranium': 'Green, rosy and fresh. Geranium adds a bright, garden-fresh lift.',
    'soft florals': 'A gentle bouquet of fresh petals. Light, pretty and easy to love.',
    'jasmine': 'Rich, heady and sweet. Jasmine on a warm summer evening.',
    'heliotrope': 'Powdery, almondy and soft. A comforting floral with a sweet, cosy edge.',
    'sea breeze': 'Salty air rolling off the North Sea. Fresh, clean and a little wild, just like home.',
    'sea air': 'A big lungful of salty coastal air. Fresh, bracing and full of memories.',
    'coastal air': 'Clean, salty coastal air. The kind you get walking the beach on a bright, windy day.',
    'ozone': 'The fresh, electric smell right after rain. Clean, airy and crisp.',
    'rock salt': 'Mineral, salty and clean. A seaside freshness that cuts through sweetness.',
    'cinnamon': 'Warm, sweet and spicy. Cinnamon is pure cosy, like a kitchen full of baking.',
    'ginger': 'Warm and zingy with a little kick. Ginger brings a lively, spicy sparkle.',
    'pink pepper': 'Rosy, fruity and lightly spicy. Pink pepper adds a bright, modern tingle.',
    'pink pepper pod': 'Rosy, fruity and lightly spicy. Pink pepper adds a bright, modern tingle.',
    'pepper pod': 'A crack of fresh pepper. Warm, dry and a little bit fiery.',
    'spice': 'A warm pinch of festive spices. Cosy, comforting and full of character.',
    'anise': 'Sweet, liquorice-like and gently warm. A soft, old-fashioned spice.',
    'nutmeg': 'Warm, nutty and festive. The grating of nutmeg over a mug of something cosy.',
    'star anise': 'Warm, sweet and liquorice-like. A pretty, star-shaped spice that makes everything feel festive.',
    'florals': 'A soft bouquet of fresh petals. Light, pretty and easy to love.',
    'clove': 'Warm, rich and gently spicy. Clove is the backbone of every Christmas kitchen.',
    'saffron': 'Golden, warm and a little leathery. A rare, luxurious spice.',
    'coffee': 'Freshly ground coffee beans. Rich, roasted and the best way to start the day.'
  };

  var FAMILIES = {
    'n-vanilla': 'A soft, creamy note that wraps the whole scent in comfort.',
    'n-citrus': 'A bright, zesty note that lifts the scent and keeps it feeling fresh.',
    'n-musk': 'A clean, soft note that gives the scent a cosy, lingering finish.',
    'n-sweet': 'A sweet, bakery-style note. Pure comfort and a little bit of nostalgia.',
    'n-amber': 'A warm, golden note that adds glow and depth.',
    'n-fruit': 'A juicy, fruity note that brings colour and brightness.',
    'n-herb': 'A fresh, green herbal note that feels clean and calming.',
    'n-pine': 'A crisp evergreen note that brings the forest indoors.',
    'n-wood': 'A warm, woody note that grounds the scent and makes it last.',
    'n-floral': 'A soft floral note that adds a fresh, pretty lift.',
    'n-sea': 'A fresh coastal note, clean and breezy like a walk by the sea.',
    'n-spice': 'A warm spice note that adds cosy character.',
    'n-coffee': 'A rich, roasted note that feels warm and inviting.',
    'n-sparkle': 'A little something special that makes this scent its own.'
  };

  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var sheet, last;

  function build() {
    sheet = document.createElement('div');
    sheet.className = 'bb-note-pop';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="bb-note-pop__scrim" data-close></div>' +
      '<div class="bb-note-pop__card" role="dialog" aria-modal="true" aria-labelledby="BbNoteTitle" tabindex="-1">' +
      '<button type="button" class="bb-note-pop__x" data-close aria-label="Close">&times;</button>' +
      '<span class="bb-note-pop__ic" aria-hidden="true"></span>' +
      '<p class="bb-note-pop__k">Scent note</p>' +
      '<h2 class="bb-note-pop__h" id="BbNoteTitle"></h2>' +
      '<p class="bb-note-pop__t"></p>' +
      '<p class="bb-note-pop__in"></p>' +
      '<a class="bb-note-pop__btn" href="#"></a>' +
      '<div class="bb-note-pop__scent" hidden></div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
  }

  function mode(scent) {
    sheet.classList.toggle('is-scent', !!scent);
    ['.bb-note-pop__ic', '.bb-note-pop__k', '.bb-note-pop__h', '.bb-note-pop__t', '.bb-note-pop__in', '.bb-note-pop__btn'].forEach(function (s) { sheet.querySelector(s).hidden = !!scent; });
    sheet.querySelector('.bb-note-pop__scent').hidden = !scent;
  }

  function show(from) {
    last = from;
    sheet.hidden = false;
    document.documentElement.classList.add('bb-note-open');
    requestAnimationFrame(function () { sheet.classList.add('is-on'); sheet.querySelector('.bb-note-pop__card').focus(); });
  }

  function describe(note) {
    var k = String(note).toLowerCase().replace(/\s+/g, ' ').trim();
    if (NOTES[k]) return NOTES[k];
    // Plurals and longer phrasings: "oranges", "pine needles", "fir branches", "red currants"
    var tries = [k.replace(/ies$/, 'y').replace(/s$/, ''), k.replace(/ (needles|branches|leaves|petals|blossoms?)$/, ''), k.replace(/^(\w+) (\w+)s$/, '$1$2'), k.split(' ').pop().replace(/s$/, '')];
    for (var i = 0; i < tries.length; i++) if (NOTES[tries[i]]) return NOTES[tries[i]];
    return '';
  }

  // Bundle shelf cards: the whole scent in one sheet (photo, notes with descriptions, price, add)
  function openCard(card) {
    if (!sheet) build();
    mode(true);
    var name = card.getAttribute('data-name') || '';
    var range = card.getAttribute('data-range-name') || '';
    var img = card.querySelector('.wx-card__img img');
    var link = card.querySelector('.wx-card__name a');
    var price = card.querySelector('.wx-card__price');
    var notesEl = card.querySelector('.wx-card__notes');
    var notes = notesEl ? notesEl.textContent.split(/\s*[·•,|]\s*/).map(function (n) { return n.trim(); }).filter(Boolean) : [];
    var picked = card.getAttribute('data-selected') === 'true';
    var html = '';
    if (img) html += '<span class="bb-scent-pop__img"><img src="' + esc(img.currentSrc || img.src) + '" alt=""></span>';
    if (range) html += '<p class="bb-note-pop__k">' + esc(range) + '</p>';
    html += '<h2 class="bb-note-pop__h" id="BbNoteTitle">' + esc(name) + '</h2>';
    if (notes.length) {
      html += '<p class="bb-scent-pop__label">Smells of</p><ul class="bb-scent-pop__notes" role="list">';
      notes.forEach(function (n) { var d = describe(n); html += '<li><b>' + esc(n) + '</b>' + (d ? '<span>' + esc(d) + '</span>' : '') + '</li>'; });
      html += '</ul>';
    }
    html += '<div class="bb-scent-pop__foot">' + (price ? '<span class="bb-scent-pop__price">' + esc(price.textContent.trim()) + '</span>' : '') +
      '<button type="button" class="bb-note-pop__btn bb-scent-pop__add" data-scent-add>' + (picked ? 'Add another' : 'Add to my set') + '</button></div>';
    if (link) html += '<a class="bb-scent-pop__more" href="' + esc(link.getAttribute('href')) + '">See the full details</a>';
    var box = sheet.querySelector('.bb-note-pop__scent');
    box.innerHTML = html;
    box.querySelector('[data-scent-add]').onclick = function () {
      var b = card.querySelector('[data-add]:not([hidden])') || card.querySelector('[data-step]:not([hidden]) [data-delta="1"]');
      if (b && !b.disabled) b.click();
      close();
    };
    show(card.querySelector('.bb-scent-info') || card);
  }

  function open(chip) {
    if (!sheet) build();
    mode(false);
    var note = chip.getAttribute('data-note') || chip.textContent.trim();
    var fam = chip.getAttribute('data-ic') || 'n-sparkle';
    var key = note.toLowerCase().replace(/\s+/g, ' ').trim();
    var label = document.querySelector('[data-bb-chips] .bb-chips__label');
    var scent = label ? label.textContent.replace(/\s*smells of\s*$/i, '').trim() : '';
    if (!scent || /^smells of$/i.test(scent)) { var h = document.querySelector('[data-bb-scent] [id^="BbScentName"]'); if (h) scent = h.textContent.trim(); }
    var svg = chip.querySelector('svg');
    sheet.querySelector('.bb-note-pop__ic').innerHTML = svg ? svg.outerHTML : '';
    sheet.querySelector('.bb-note-pop__h').textContent = note;
    sheet.querySelector('.bb-note-pop__t').textContent = NOTES[key] || FAMILIES[fam] || FAMILIES['n-sparkle'];
    var inEl = sheet.querySelector('.bb-note-pop__in');
    inEl.innerHTML = scent && !/^smells of$/i.test(scent) ? 'You’ll find it in <b>' + esc(scent) + '</b>.' : '';
    inEl.hidden = !inEl.innerHTML;
    var btn = sheet.querySelector('.bb-note-pop__btn');
    btn.href = root + 'search?type=product&q=' + encodeURIComponent(note);
    btn.textContent = 'More scents with ' + note.toLowerCase();
    show(chip);
  }

  function close() {
    sheet.classList.remove('is-on');
    document.documentElement.classList.remove('bb-note-open');
    setTimeout(function () { sheet.hidden = true; }, 220);
    if (last) last.focus();
  }

  // Info buttons on the bundle shelf cards
  function addInfo() {
    document.querySelectorAll('.wx--shelf .wx-card').forEach(function (card) {
      if (card.querySelector('.bb-scent-info')) return;
      var media = card.querySelector('.wx-card__img'); if (!media) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bb-scent-info';
      b.setAttribute('aria-label', 'About ' + (card.getAttribute('data-name') || 'this scent'));
      b.setAttribute('aria-haspopup', 'dialog');
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="7.2" r="1.5" fill="currentColor"/><path d="M12 11v7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none"/></svg>';
      media.parentNode.insertBefore(b, media);
    });
  }
  // Fill the one-line descriptions on the product page "How it unfolds" card (and again when it re-renders on a scent change)
  function fillDesc() {
    document.querySelectorAll('[data-note-desc]:empty').forEach(function (el) {
      var b = el.closest('[data-note]'); if (!b) return;
      var t = describe(b.getAttribute('data-note')) || FAMILIES[b.getAttribute('data-ic')] || '';
      if (t) el.textContent = t.split(/(?<=\.)\s/)[0];
    });
  }
  function boot() {
    addInfo(); fillDesc();
    var card = document.querySelector('[data-bb-scent]');
    if (card) { var q; new MutationObserver(function () { if (q) return; q = requestAnimationFrame(function () { q = 0; fillDesc(); }); }).observe(card, { childList: true, subtree: true }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('click', function (e) {
    var info = e.target.closest && e.target.closest('.bb-scent-info');
    if (info) { e.preventDefault(); e.stopPropagation(); openCard(info.closest('.wx-card')); return; }
    var chip = e.target.closest && e.target.closest('.bb-chip[data-note], .bb-note[data-note]');
    if (!chip) return;
    e.preventDefault();
    open(chip);
  });

  window.bbNotes = { open: open, openCard: openCard, close: close, describe: describe };
})();
